<template>
    <div class="card p-0" :class="{'active': active}">
        <div class="card-header">
            <div class="flex-row d-flex justify-content-between align-items-center cursor-pointer" v-on:click="toggleExpanded()">
                <h5 class="mb-0">
                    <span>
                        <i class="fa" :class="{'fa-chevron-down': !expanded, 'fa-chevron-up': expanded}"></i>
                    </span>
                    {{ os ? os : 'Unknown Subscription'}}
                </h5>
                <div class="subscription-created-at">
                    {{ humanReadableCreatedAt }}
                </div>
            </div>
        </div>
        <div v-if="expanded" class="card-body">
            <!-- iterate over deviceInfo if deviceInfo -->
            <div v-if="deviceInfo">
                <div class='device-info-field' v-for="(value, key) in deviceInfo" :key="key">
                    <strong>{{ getUserFriendlyDisplayForDeviceInfoKey(key) }}:</strong> {{ value }}
                </div>
            </div>

            <div class="device-info-field">
                <strong>Created At:</strong> {{ humanReadableCreatedAt }}
            </div>
        </div>

        <div class="card-footer">
            <button class="btn btn-primary" @click="createTestPushNotification">
                Test Notification
            </button>
        </div>
    </div>
</template>

<script>
    import { active } from 'd3';
    import Moment from 'moment';
    import Vue from 'vue';
    import {
        BCard,
        BSkeleton,
    } from 'bootstrap-vue';

    var toastConfig = {
        duration: 4000,
        position: "bottom-right",
        action: {
            text: "DISMISS",
            onClick: (e, toastObject) => {
            toastObject.goAway(0);
            },
        },
    };

    export default {

        components: {
            BCard,
            BSkeleton,
        },

        props: {
            subscription: {
                required: true,
            },
            active: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            deviceInfo: function () {
                if (this.subscription.metadata && this.subscription.metadata.device_info) {
                    return this.subscription.metadata.device_info;
                }
                return null;
            },

            os: function () {
                if (this.deviceInfo && this.deviceInfo.os) {
                    return this.deviceInfo.os;
                }
                return null;
            },

            humanReadableCreatedAt () {
                // mm/dd/yy, h:mm:ss a
                return Moment(this.subscription.created_at).format('MM/DD/YY, h:mm:ss a');
            },
        },

        methods: {

            emitSubscriptionExpired () {
                this.$emit('subscription-expired', this.subscription.id);
            },

            toggleExpanded () {
                this.expanded = !this.expanded;
            },

            createTestPushNotification () {
                axios.post('/api/v1/push-subscriptions/' + this.subscription.id + '/send-test-notification')
                    .then(response => {
                        if (response.data.expired) {
                            Vue.toasted.error('This subscription has expired.', toastConfig);
                            // emit event to parent to refresh subscriptions
                            this.emitSubscriptionExpired();
                            return
                        }
                        Vue.toasted.success('This subscription appears to be active. Please check your notifications for this device.', toastConfig);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            getUserFriendlyDisplayForDeviceInfoKey (key) {
                // keys are os, browser, language, timeZone, deviceMake, deviceType, if matched make a user friendly display
                if (key === 'os') {
                    return 'Operating System';
                } else if (key === 'browser') {
                    return 'Browser';
                } else if (key === 'language') {
                    return 'Language';
                } else if (key === 'timeZone') {
                    return 'Time Zone';
                } else if (key === 'deviceMake') {
                    return 'Device Make';
                } else if (key === 'deviceType') {
                    return 'Device Type';
                }
                return key;   
            }
        },

        data: function () {
            return {
                expanded: false,
            };
        },


    }
</script>

<style scoped>

    .card.active {
        border: 1px solid #007bff;
    }

</style>